import { useEffect } from 'react';
import HeaderStyleTwo from '../Shared/HeaderStyleTwo';
import { LionPlayer } from 'lion-player';
import Footer from '../Shared/Footer';
import VolunteersBanner from '../Shared/VolunteersBanner';
const ApnaRozgar = () => {
  useEffect(() => {
    runJQueryScripts();
  }, []);

  const runJQueryScripts = () => {
    let tag: any;
    let loadScript = function (src: string) {
      tag = document.createElement('script');
      tag.async = false;
      tag.src = src;
      document.getElementsByTagName('body')[0].appendChild(tag);
    };
    loadScript('../assets/js/jquery.js');
    loadScript('../assets/js/popper.min.js');
    loadScript('../assets/js/jquery-ui.js');
    loadScript('../assets/js/jquery.fancybox.js');
    loadScript('../assets/js/owl.js');
    loadScript('../assets/js/appear.js');
    loadScript('../assets/js/wow.js');
    loadScript('../assets/js/lazyload.js');
    loadScript('../assets/js/scrollbar.js');
    loadScript('../assets/js/script.js');
    return () => {
      document.getElementsByTagName('body')[0].removeChild(tag);
    };
  };
  return (
    <>
      <HeaderStyleTwo />
      <div className='ulockd-inner-page'>
        <div className='container'>
          <div className='row'>
            <div className='col-md-12'>
              <div className='ulockd-icd-layer'>
                <ul className='list-inline ulockd-icd-sub-menu'>
                  <li>
                    <a style={{ color: '#25283a' }} href='/'>
                      {' '}
                      Home{' '}
                    </a>
                  </li>
                  <li>
                    <a style={{ color: '#25283a' }} href='#'>
                      <b> / </b>
                    </a>
                  </li>
                  <li>
                    {' '}
                    <a href='/apna-rozgar'>
                      Apna Rozgar (Small Business Setups)
                    </a>{' '}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className='sidebar-page-container'
        style={{ padding: '50px 0px 0px' }}
      >
        <div className='auto-container'>
          <div className='row clearfix'>
            <div className='content-side col-lg-8 col-md-12 col-sm-12'>
              <div className='cause-details'>
                <div className='inner-box'>
                  <div className='image-box'>
                    <figure className='image'>
                      <a href='/get-involved'>
                        <img
                          className='lazy-image'
                          src='assets/images/resource/image-spacer-for-validation.png'
                          data-src='assets/images/resource/apna-rozgar.jpg'
                          alt=''
                        />
                      </a>{' '}
                    </figure>
                  </div>
                  <div
                    className='lower-content'
                    style={{ padding: '40px 0 0' }}
                  >
                    <div className='text-content'>
                      <h2>
                        <a href='/get-involved'>
                          Apna Rozgar (Small Business Setups)
                        </a>
                      </h2>

                      <p>
                        Alhamdulillah by the grace of <b>Allah Almighty</b>,
                        Sadqa-E-Jariya Welfare Foundation installed{' '}
                        <b> 125 Small Business Setups </b> for needy/less
                        fortunate people in Pakistan.
                      </p>
                      <ul>
                        <li>49 carts and support setups</li>
                        <li>
                          10 motorbikes for door to door salesman and delivery
                          business.
                        </li>
                        <li>33 Sewing machines.</li>
                        <li>3 Auto Rickshaws.</li>
                      </ul>
                      <section
                        className='news-section'
                        style={{ paddingTop: 0, paddingBottom: 20 }}
                      >
                        <div className='auto-container' style={{ padding: 0 }}>
                          <div className='row clearfix'>
                            <div className='news-block col-lg-12 col-md-12 col-sm-12'>
                              <div
                                className='inner-box wow fadeInUp'
                                data-wow-delay='0ms'
                              >
                                <div
                                  className='lower-content'
                                  style={{ padding: 5 }}
                                >
                                  <div id='video_block_one'>
                                    <div
                                      className='video-inner'
                                      style={{ padding: 5 }}
                                    >
                                      <LionPlayer
                                        sources={
                                          '../assets/video/apna-rozgar/apna-rozgar.mp4'
                                        }
                                      />
                                    </div>
                                  </div>
                                  {/* <h3>
                                    Free Grocery for Widows and Senior Citizen
                                  </h3> */}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </section>
                      <section className='insta-gallery'>
                        <div
                          className='insta-gallery-carousel love-carousel owl-theme owl-carousel'
                          data-options='{"loop": false, "margin": 0, "autoheight":true, "lazyload":true, "nav": true, "dots": true, "autoplay": true, "autoplayTimeout": 5000, "smartSpeed": 500, "responsive":{ "0" :{ "items": "1" },"600" :{ "items": "2" }, "768" :{ "items" : "3" }, "1024":{ "items" : "4" }, "1366":{ "items" : "4" }, "1500":{ "items" : "5" }, "1920":{ "items" : "6" }}}'
                        >
                          <div className='gallery-item'>
                            <div className='image-box'>
                              <figure className='image'>
                                <img
                                  className='lazy-image owl-lazy'
                                  src='assets/images/resource/image-spacer-for-validation.png'
                                  data-src='assets/images/gallery/apna-rozgar-cart-001-thumbnail.jpg'
                                  alt=''
                                />
                              </figure>
                              <div className='overlay-box'>
                                <a
                                  href='../assets/images/gallery/apna-rozgar-cart-001-original.jpg'
                                  className='lightbox-image'
                                  data-fancybox='gallery'
                                >
                                  <span className='icon flaticon-instagram'></span>
                                </a>
                              </div>
                            </div>
                          </div>
                          <div className='gallery-item'>
                            <div className='image-box'>
                              <figure className='image'>
                                <img
                                  className='lazy-image owl-lazy'
                                  src='assets/images/resource/image-spacer-for-validation.png'
                                  data-src='assets/images/gallery/apna-rozgar-cart-002-thumbnail.jpg'
                                  alt=''
                                />
                              </figure>
                              <div className='overlay-box'>
                                <a
                                  href='../assets/images/gallery/apna-rozgar-cart-002-original.jpg'
                                  className='lightbox-image'
                                  data-fancybox='gallery'
                                >
                                  <span className='icon flaticon-instagram'></span>
                                </a>
                              </div>
                            </div>
                          </div>
                          <div className='gallery-item'>
                            <div className='image-box'>
                              <figure className='image'>
                                <img
                                  className='lazy-image owl-lazy'
                                  src='assets/images/resource/image-spacer-for-validation.png'
                                  data-src='assets/images/gallery/apna-rozgar-cart-005-thumbnail.jpg'
                                  alt=''
                                />
                              </figure>
                              <div className='overlay-box'>
                                <a
                                  href='../assets/images/gallery/apna-rozgar-cart-005-original.jpg'
                                  className='lightbox-image'
                                  data-fancybox='gallery'
                                >
                                  <span className='icon flaticon-instagram'></span>
                                </a>
                              </div>
                            </div>
                          </div>
                          <div className='gallery-item'>
                            <div className='image-box'>
                              <figure className='image'>
                                <img
                                  className='lazy-image owl-lazy'
                                  src='assets/images/resource/image-spacer-for-validation.png'
                                  data-src='assets/images/gallery/apna-rozgar-cart-009-thumbnail.jpg'
                                  alt=''
                                />
                              </figure>
                              <div className='overlay-box'>
                                <a
                                  href='../assets/images/gallery/apna-rozgar-cart-009-original.jpg'
                                  className='lightbox-image'
                                  data-fancybox='gallery'
                                >
                                  <span className='icon flaticon-instagram'></span>
                                </a>
                              </div>
                            </div>
                          </div>
                          <div className='gallery-item'>
                            <div className='image-box'>
                              <figure className='image'>
                                <img
                                  className='lazy-image owl-lazy'
                                  src='assets/images/resource/image-spacer-for-validation.png'
                                  data-src='assets/images/gallery/apna-rozgar-cart-10-thumbnail.jpg'
                                  alt=''
                                />
                              </figure>
                              <div className='overlay-box'>
                                <a
                                  href='../assets/images/gallery/apna-rozgar-cart-10-original.jpg'
                                  className='lightbox-image'
                                  data-fancybox='gallery'
                                >
                                  <span className='icon flaticon-instagram'></span>
                                </a>
                              </div>
                            </div>
                          </div>
                          <div className='gallery-item'>
                            <div className='image-box'>
                              <figure className='image'>
                                <img
                                  className='lazy-image owl-lazy'
                                  src='assets/images/resource/image-spacer-for-validation.png'
                                  data-src='assets/images/gallery/apna-rozgar-pan-shop-001-thumbnail.jpg'
                                  alt=''
                                />
                              </figure>
                              <div className='overlay-box'>
                                <a
                                  href='../assets/images/gallery/apna-rozgar-pan-shop-001-original.jpg'
                                  className='lightbox-image'
                                  data-fancybox='gallery'
                                >
                                  <span className='icon flaticon-instagram'></span>
                                </a>
                              </div>
                            </div>
                          </div>
                          <div className='gallery-item'>
                            <div className='image-box'>
                              <figure className='image'>
                                <img
                                  className='lazy-image owl-lazy'
                                  src='assets/images/resource/image-spacer-for-validation.png'
                                  data-src='assets/images/gallery/apna-rozgar-toy-shop-001-thumbnail.jpg'
                                  alt=''
                                />
                              </figure>
                              <div className='overlay-box'>
                                <a
                                  href='../assets/images/gallery/apna-rozgar-toy-shop-001-original.jpg'
                                  className='lightbox-image'
                                  data-fancybox='gallery'
                                >
                                  <span className='icon flaticon-instagram'></span>
                                </a>
                              </div>
                            </div>
                          </div>
                          {/* <div className="gallery-item">
                                                        <div className="image-box">
                                                            <figure className="image"><img className="lazy-image owl-lazy" src="assets/images/resource/image-spacer-for-validation.png" data-src="assets/images/gallery/apna-rozgar-cloths-shop-001-thumbnail.jpg" alt="" /></figure>
                                                            <div className="overlay-box"><a href="../assets/images/gallery/apna-rozgar-cloths-shop-001-original.jpg" className="lightbox-image" data-fancybox="gallery"><span className="icon flaticon-instagram"></span></a></div>
                                                        </div>
                                                    </div> */}
                          <div className='gallery-item'>
                            <div className='image-box'>
                              <figure className='image'>
                                <img
                                  className='lazy-image owl-lazy'
                                  src='assets/images/resource/image-spacer-for-validation.png'
                                  data-src='assets/images/gallery/thumbnail/apna-rozgar-shop-equipment-prayer-mats.jpg'
                                  alt=''
                                />
                              </figure>
                              <div className='overlay-box'>
                                <a
                                  href='../assets/images/gallery/original/apna-rozgar-shop-equipment-prayer-mats.jpg'
                                  className='lightbox-image'
                                  data-fancybox='gallery'
                                >
                                  <span className='icon flaticon-instagram'></span>
                                </a>
                              </div>
                            </div>
                          </div>
                          <div className='gallery-item'>
                            <div className='image-box'>
                              <figure className='image'>
                                <img
                                  className='lazy-image owl-lazy'
                                  src='assets/images/resource/image-spacer-for-validation.png'
                                  data-src='assets/images/gallery/thumbnail/apna-rozgar-shop-equipment-prayer-mats1.jpg'
                                  alt=''
                                />
                              </figure>
                              <div className='overlay-box'>
                                <a
                                  href='../assets/images/gallery/original/apna-rozgar-shop-equipment-prayer-mats1.jpg'
                                  className='lightbox-image'
                                  data-fancybox='gallery'
                                >
                                  <span className='icon flaticon-instagram'></span>
                                </a>
                              </div>
                            </div>
                          </div>
                          <div className='gallery-item'>
                            <div className='image-box'>
                              <figure className='image'>
                                <img
                                  className='lazy-image owl-lazy'
                                  src='assets/images/resource/image-spacer-for-validation.png'
                                  data-src='assets/images/gallery/thumbnail/apna-rozgar-sewing-machines1.jpg'
                                  alt=''
                                />
                              </figure>
                              <div className='overlay-box'>
                                <a
                                  href='../assets/images/gallery/original/apna-rozgar-sewing-machines1.jpg'
                                  className='lightbox-image'
                                  data-fancybox='gallery'
                                >
                                  <span className='icon flaticon-instagram'></span>
                                </a>
                              </div>
                            </div>
                          </div>
                          <div className='gallery-item'>
                            <div className='image-box'>
                              <figure className='image'>
                                <img
                                  className='lazy-image owl-lazy'
                                  src='assets/images/resource/image-spacer-for-validation.png'
                                  data-src='assets/images/gallery/thumbnail/apna-rozgar-sewing-machines.jpg'
                                  alt=''
                                />
                              </figure>
                              <div className='overlay-box'>
                                <a
                                  href='../assets/images/gallery/original/apna-rozgar-sewing-machines.jpg'
                                  className='lightbox-image'
                                  data-fancybox='gallery'
                                >
                                  <span className='icon flaticon-instagram'></span>
                                </a>
                              </div>
                            </div>
                          </div>
                          <div className='gallery-item'>
                            <div className='image-box'>
                              <figure className='image'>
                                <img
                                  className='lazy-image owl-lazy'
                                  src='assets/images/resource/image-spacer-for-validation.png'
                                  data-src='assets/images/gallery/thumbnail/apna-rozgar-apna-auto-01.jpg'
                                  alt=''
                                />
                              </figure>
                              <div className='overlay-box'>
                                <a
                                  href='../assets/images/gallery/original/apna-rozgar-apna-auto-01.jpg'
                                  className='lightbox-image'
                                  data-fancybox='gallery'
                                >
                                  <span className='icon flaticon-instagram'></span>
                                </a>
                              </div>
                            </div>
                          </div>
                          <div className='gallery-item'>
                            <div className='image-box'>
                              <figure className='image'>
                                <img
                                  className='lazy-image owl-lazy'
                                  src='assets/images/resource/image-spacer-for-validation.png'
                                  data-src='assets/images/gallery/thumbnail/apna-rozgar-apna-auto-02.jpg'
                                  alt=''
                                />
                              </figure>
                              <div className='overlay-box'>
                                <a
                                  href='../assets/images/gallery/original/apna-rozgar-apna-auto-02.jpg'
                                  className='lightbox-image'
                                  data-fancybox='gallery'
                                >
                                  <span className='icon flaticon-instagram'></span>
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </section>
                      <br />
                      <p>
                        Invest your money to gain pleasure of <b>ALLAH</b>.
                      </p>
                      <br />
                      <h3>Your help turns into smiles.</h3>
                    </div>
                    <div className='link-box'>
                      <a
                        href='/get-involved'
                        className='theme-btn btn-style-one'
                      >
                        <span className='btn-title'>Donate Now</span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className='sidebar-side col-lg-4 col-md-12 col-sm-12'>
              <aside className='sidebar'>
                <div className='sidebar-widget categories'>
                  <div className='text'>
                    <b>
                      You can be a part of the change in this world. Give a
                      helping hand to those who need it!
                    </b>
                  </div>

                  <h3 className='sidebar-title'>Our Programs</h3>
                  <div className='widget-content'>
                    <ul>
                      <li className='current'>
                        <a href='/apna-rozgar'>
                          Apna Rozgar (Small Business Setups)
                        </a>
                      </li>
                      <li>
                        <a href='/free-grocery-for-widows-and-senior-citizen'>
                          Free Grocery for Widows and Senior Citizen
                        </a>
                      </li>
                      <li>
                        <a href='/medical-support'>Free Medical Support</a>
                      </li>
                      <li>
                        <a href='/basic-schools'>
                          Free Education for Child (Basic Schools)
                        </a>
                      </li>
                      <li>
                        <a href='/water-hand-pumps'>
                          Clean Water Program (Water Hand Pumps)
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>

                {/* <div className="sidebar-widget popular-posts">
                                    <h3 className="sidebar-title">Latest News</h3>
                                    <div className="widget-content">
                                        <div className="news-post">
                                            <div className="post-thumb"><a href="blog-single.html"><img className="lazy-image" src="images/resource/image-spacer-for-validation.png" data-src="images/resource/post-thumb-6.jpg" alt="" /></a></div>
                                            <div className="date"><span className="fa fa-calendar-alt"></span> Sep 25, 2019</div>
                                            <h4><a href="blog-single.html">Consequntur magni dolore eos qui. </a></h4>
                                        </div>
                                        <div className="news-post">
                                            <div className="post-thumb"><a href="blog-single.html"><img className="lazy-image" src="images/resource/image-spacer-for-validation.png" data-src="images/resource/post-thumb-7.jpg" alt="" /></a></div>
                                            <div className="date"><span className="fa fa-calendar-alt"></span> Sep 20, 2019</div>
                                            <h4><a href="blog-single.html">Magni dolore eos qui ratione seque.</a></h4>
                                        </div>
                                        <div className="news-post">
                                            <div className="post-thumb"><a href="blog-single.html"><img className="lazy-image" src="images/resource/image-spacer-for-validation.png" data-src="images/resource/post-thumb-8.jpg" alt="" /></a></div>
                                            <div className="date"><span className="fa fa-calendar-alt"></span> Sep 14, 2019</div>
                                            <h4><a href="blog-single.html">Ratone magni dolore eos qui ratione.</a></h4>
                                        </div>
                                    </div>
                                </div> */}

                {/* <div className="sidebar-widget popular-tags">
                                    <h3 className="sidebar-title">Popular Tags</h3>
                                    <div className="widget-content">
                                        <ul className="clearfix">
                                            <li><a href="blog-single.html">Education</a></li>
                                            <li><a href="blog-single.html">Olympiad</a></li>
                                            <li><a href="blog-single.html">Children</a></li>
                                            <li><a href="blog-single.html">Animals</a></li>
                                            <li><a href="blog-single.html">Donations</a></li>
                                            <li><a href="blog-single.html">Causes</a></li>
                                            <li><a href="blog-single.html">Drawing</a></li>
                                            <li><a href="blog-single.html">Art</a></li>
                                        </ul>
                                    </div>
                                </div> */}
              </aside>
            </div>
          </div>
        </div>
      </div>
      {/* <VolunteersBanner /> */}
      <Footer />
    </>
  );
};
export default ApnaRozgar;
